export default __webpack_public_path__ + "static/media/up-right-arrow.c157a0a2.svg";